// Importar acciones
import * as authActions from "../actions/auth";
import * as userActions from "../actions/user";

// Importar dependencias
import AuthServices from "@/services/AuthServices";
import BusinessServices from "@/services/BusinessServices";
import ApiClient from "@/services/ApiClient";
import Items from "@/utils/items.js";
import Vue from "vue";

// Declarar estado
const state = {
  token: localStorage.getItem("auth-token") || null,
  homeRoute: ""
};

// Declarar getters
const getters = {
  isAuthenticated: state => !!state.token,
  getHomeRoute: state => state.homeRoute
};

// Declarar acciones
const actions = {
  [authActions.SIGN_UP_OWNER_REQUEST]: async function({ commit }, data) {
    // Commit del registro del dueño
    commit(authActions.AUTH_REQUEST);

    try {
      // Obtener datos
      const user = data.user;
      const business = data.business;

      // Llamar al servidor
      const { token, profile } = await AuthServices.signUpOwner(user, business);

      // Guardar datos en localStorage
      localStorage.setItem("auth-token", token);

      // Configurar token en los headers globales
      ApiClient.defaults.headers.common["auth-token"] = token;

      // Commit del registro exitoso del generador
      commit(authActions.AUTH_SUCCESS, token);

      // Commit de la respuesta exitos
      commit(userActions.PROFILE_SUCCESS, profile);

      // Commit para actualizar la url de la página de inicio
      commit(authActions.HOME_ROUTE_UPDATE, "dashboard");

      // Devolver token
      return {
        token
      };
    } catch (err) {
      commit(authActions.AUTH_ERROR);
      throw new Error(err.message);
    }
  },
  [authActions.SIGN_IN_REQUEST]: async function({ commit }, user) {
    // Commit del inicio de sesión
    commit(authActions.AUTH_REQUEST);

    try {
      // Realizar petición
      const { token, profile } = await AuthServices.signIn(
        user.email,
        user.password
      );

      // Guardar datos en localStorage
      localStorage.setItem("auth-token", token);

      // Configurar token en los headers globales
      ApiClient.defaults.headers.common["auth-token"] = token;

      // Commit del registro exitoso del generador
      commit(authActions.AUTH_SUCCESS, token);

      // Commit de la respuesta exitos
      commit(userActions.PROFILE_SUCCESS, profile);

      // Obtener negocio
      const business = await BusinessServices.getBusiness();

      // Commit de la respuesta de negocio
      commit(userActions.BUSINESS_SUCCESS, business);

      // Obtener primera pestaña
      const { key: firstTab } =
        profile.tabs && profile.tabs?.length > 0
          ? Items.authenticated.find(item => profile.tabs.includes(item.key))
          : { key: "settings" };

      // Commit para actualizar la url de la página de inicio
      if (profile.user_type === "employee") {
        commit(authActions.HOME_ROUTE_UPDATE, firstTab);
      } else {
        commit(authActions.HOME_ROUTE_UPDATE, "dashboard");
      }

      // Devolver token
      return {
        token,
        id: profile._id,
        profile
      };
    } catch (err) {
      commit(authActions.AUTH_ERROR);
      throw new Error(err.message);
    }
  },
  [authActions.SIGN_OUT_REQUEST]: function({ commit }) {
    // Commit del cierre de sesión
    commit(authActions.SIGN_OUT_REQUEST);

    // Eliminar token del localStorage
    localStorage.removeItem("auth-token");

    // Remover token de los headers globales
    delete ApiClient.defaults.headers.common["auth-token"];

    // Eliminar perfil del usuario
    commit(userActions.DELETE_PROFILE);

    // Commit del cierre de sesión exitoso
    commit(authActions.SIGN_OUT_SUCCESS);

    // Commit para actualizar la url de la página de inicio
    commit(authActions.HOME_ROUTE_UPDATE, "home");
  }
};

// Declarar mutaciones
const mutations = {
  [authActions.AUTH_REQUEST]: state => {
    state.status = "loading";
  },
  [authActions.AUTH_SUCCESS]: (state, token) => {
    state.status = "success";
    state.token = token;
  },
  [authActions.AUTH_ERROR]: state => {
    state.status = "error";
  },
  [authActions.SIGN_OUT_REQUEST]: state => {
    state.status = "signing-out";
  },
  [authActions.SIGN_OUT_SUCCESS]: state => {
    // Remover el token del estado
    Vue.set(state, "token", null);
    state.status = "success";
  },
  [authActions.HOME_ROUTE_UPDATE]: (state, routeName) => {
    state.homeRoute = routeName;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
